import { withStyles } from '@material-ui/core';
import Label from './Label';
import Value from './Value';

const styles = (theme) => ({
  container: {
    flexGrow: 1,
    marginRight : 8
  },
  value: {
    marginTop: 4,
    wordBreak: 'break-word',
    width: '90%',
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 500
  },
  fullWidth: {
    flexGrow: 'unset',
    width: '100%'
  }
});
const Detail = ({
  label,
  value,
  upperCaseLabel = false,
  classes,
  isFullWidth,
  customValueClasses,
  detailContainerClasses
}) => (
  <div
    className={`${detailContainerClasses ?? classes.container} ${
      isFullWidth ? classes.fullWidth : ''
    }`}>
    <Label labelText={label} upperCase={upperCaseLabel} />
    <Value value={value} customClasses={customValueClasses ?? classes.value} />
  </div>
);

export default withStyles(styles)(Detail);
